import { render, staticRenderFns } from "./PageHeadingInfo.vue?vue&type=template&id=7e3a775b&scoped=true&"
import script from "./PageHeadingInfo.vue?vue&type=script&lang=js&"
export * from "./PageHeadingInfo.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadingInfo.vue?vue&type=style&index=0&id=7e3a775b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3a775b",
  null
  
)

export default component.exports